import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useContext, useMemo, useState } from "react";

import classnames from "classnames";
import _ from "lodash";
import { AppContext } from "../../AppContext";
import pencilIcon from "../../images/Pincel.svg";
import arrowIcon from "../../images/ri_arrow-up-s-line.svg";
import OrderStatusIcon from "../../pages/PosPage/components/OrderStatusIcon";
import { useAddons } from "../../shared/hooks/useItemsData";
import { useRemoveItemFromTableOrderData } from "../../shared/hooks/useTableOrderItemsData";
import { useStyles } from "./styles";

const OrderItemCard = ({ item, expanded, onChange, order }) => {
    const classes = useStyles();

    const [selectedOrder, setSelectedOrder] = useState(null);
    const { data: addons } = useAddons();

    const [itemAddons, setItemAddons] = useState([]);

    let removeOrderItemMutation = useRemoveItemFromTableOrderData();

    const { menuItems } = useContext(AppContext);

    useMemo(() => {
        const tmpItemAddons = [];
        item.addons &&
            JSON.parse(item.addons).forEach((addon) => {
                const lowerAddon = _.toLower(addon);
                const foundAddon = _.find(
                    addons,
                    (a) => _.toLower(a.item_code) === lowerAddon
                );
                if (foundAddon) {
                    tmpItemAddons.push(foundAddon);
                }
            });

        setItemAddons(tmpItemAddons);
    }, [addons]);

    const handleDeleteOrderItemRequest = (item) => {
        if (!order || !order.name || !item) {
            return;
        }

        removeOrderItemMutation.mutate({
            orderId: order.name,
            item: item,
        });
    };

    const handleOrderItemEdit = (item) => {
        const deleteEvent = new CustomEvent("itemEdit", {
            detail: { orderItem: item },
        });
        document.dispatchEvent(deleteEvent);
    };

    const getOnChange = () => {
        if (item.addons && JSON.parse(item.addons).length > 0) {
            return onChange;
        } else {
            return () => {};
        }
    };

    const getIcon = () => {
        let classesName = classes.Arrow_disabled;
        if (item.addons && JSON.parse(item.addons).length > 0) {
            classesName = classes.Arrow_enabled;
        }
        return (
            <div className={classesName}>
                <div>
                    <img src={arrowIcon} />
                </div>
            </div>
        );
    };

    const checkCanEdit = (item) => {
        return item.status === "Attending";
    };

    const getTotalPrice = (item) => {
        let totalCost = item.rate;

        if (itemAddons && itemAddons.length > 0) {
            totalCost += itemAddons.reduce(
                (sum, addon) => sum + addon.standard_rate,
                0
            );
        }

        return totalCost;
    };

    return (
        <>
            <Accordion
                expanded={expanded === item.entry_name}
                onChange={getOnChange()}
                className={classes.Accordion}
            >
                <AccordionSummary
                    aria-controls={item.entry_name + "-content"}
                    id={item.entry_name + "-header"}
                    expandIcon={getIcon()}
                    className={classes.AccordionSummary}
                >
                    <div
                        className={classnames("Item", {
                            IsSelected: item.item_code == selectedOrder,
                        })}
                        onClick={() => setSelectedOrder(item)}
                    >
                        <div className="Item__Main">
                            <div className="Content">
                                <div className="Img">
                                    <div
                                        className="Img"
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                        }}
                                    >
                                        {item && item.item_code && menuItems ? (
                                            <img
                                                src={
                                                    menuItems.find(
                                                        (i) =>
                                                            i.item_code ===
                                                            item.item_code
                                                    ).cover
                                                }
                                                alt="Image"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                }}
                                            />
                                        ) : (
                                            <div>No image available</div>
                                        )}{" "}
                                    </div>
                                </div>
                                <div className="Name">
                                    <div>{item.item_name}</div>
                                    <div>x {item.qty}</div>
                                </div>
                            </div>
                            <div className="Item_2">
                                <div className="Item__Secondary">
                                    <div className="PostActions">
                                        <div>NIS {getTotalPrice(item)}</div>
                                        <OrderStatusIcon status={item.status} />
                                        {checkCanEdit(item) ? (
                                            <div>
                                                <i
                                                    className="bx bxs-trash"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleDeleteOrderItemRequest(
                                                            item
                                                        );
                                                    }}
                                                ></i>
                                                <i
                                                    className={
                                                        classes.Table_edit_order_right
                                                    }
                                                    onClick={() =>
                                                        handleOrderItemEdit(
                                                            item
                                                        )
                                                    }
                                                >
                                                    <img src={pencilIcon} />
                                                </i>
                                            </div>
                                        ) : (
                                            <div></div> // Provide a fallback element when the condition is not met
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AccordionSummary>

                <AccordionDetails style={{ padding: 0 }}>
                    <div className="Item">
                        <div className="Item__Secondary">
                            {itemAddons &&
                                itemAddons.map((i, index) => {
                                    return (
                                        <div
                                            key={
                                                "ItemAddons_" +
                                                item.name +
                                                "_" +
                                                i.item_code
                                            }
                                        >
                                            <span>- {i.item_code}</span>
                                            <span>+ {i.standard_rate}</span>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default OrderItemCard;
